module.exports = __webpack_public_path__ + "dot.de7ffc56.gif";